var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 47.5,
    height: 47.5,
    rx: 7.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 47.5,
    height: 47.5,
    rx: 7.75,
    stroke: "#D1D6DB",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6104 24.2792C38.6104 23.1949 38.5131 22.1523 38.3324 21.1514H23.9307V27.0664H32.1602C31.8057 28.9778 30.7284 30.5973 29.1089 31.6816V35.5183H34.0508C36.9423 32.8563 38.6104 28.9361 38.6104 24.2792Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9306 39.223C28.0593 39.223 31.5207 37.8537 34.0507 35.5183L29.1088 31.6815C27.7395 32.599 25.988 33.1411 23.9306 33.1411C19.9479 33.1411 16.5768 30.4512 15.3743 26.8369H10.2656V30.7988C12.7818 35.7963 17.953 39.223 23.9306 39.223Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3748 26.8368C15.069 25.9193 14.8952 24.9393 14.8952 23.9314C14.8952 22.9236 15.069 21.9436 15.3748 21.0261V17.0642H10.2661C9.23045 19.1286 8.63965 21.464 8.63965 23.9314C8.63965 26.3989 9.23045 28.7343 10.2661 30.7987L15.3748 26.8368Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9306 14.722C26.1756 14.722 28.1913 15.4935 29.7761 17.0087L34.1619 12.6229C31.5137 10.1554 28.0523 8.64014 23.9306 8.64014C17.953 8.64014 12.7818 12.0668 10.2656 17.0643L15.3743 21.0262C16.5768 17.4118 19.9479 14.722 23.9306 14.722Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMobile);
export default __webpack_public_path__ + "static/media/google-mobile.b2e9a87298c94b0f5e84fb7f8fc2bab4.svg";
export { ForwardRef as ReactComponent };